<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Bundled Transactions</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <!--            <div class="mr-2">
                          <bulk-upload-student v-if="pagepermission.insertable" @created="handleCreated"/>
                        </div>
                        <div>
                          <add-student v-if="pagepermission.insertable" @created="handleCreated"/>
                        </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center mb-2">
          <!-- Transaction Type Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
                size="large"
                v-model="selectedType"
                placeholder="All Types"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleTypeChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="false"
              >
                <a-select-option value="undefined">All Types</a-select-option>
                <a-select-option value="In">In</a-select-option>
                <a-select-option value="Out">Out</a-select-option>
              </a-select>
            </a-spin>
          </div>
          <!-- Product Search -->
          <div class="col-md-6 col-12 mb-2" v-if="!selectedRowKeys.length">
            <div class="text-right">
              <a-input-search
                placeholder="Search Product..."
                size="large"
                v-model="search"
                @search="searchProduct"
              />
            </div>
          </div>
          <div class="col-md-6 col-12 mb-2 text-md-right" v-else>
            <a href="javascript:;" class="btn btn btn-danger btn-with-addon"
               @click="handleDeleteSelected"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete Selected
            </a>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <BundledProductsTransactionTable :rolesetting="pagepermission" :data="data" :loading="loading" :session="selectedSession" @updateTable="handleUpdateTable" @selectChange="handleTableSelect"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">You don't have permission to use this feature.</p>
    </div>
  </div>
</template>

<script>
import BundledProductsTransactionTable from '@/components/inventory/bundled_products_transaction/BundledProductsTransactionTable'
import { debounce, find } from 'lodash'
export default {
  components: {
    BundledProductsTransactionTable,
  },
  beforeMount: function () {
    let rc = this.$roleutility.checkpermission('inventory', 22)
    rc.then(data => {
      // console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getProductTransactions()
  },
  /* mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
        this.getProductTransactions()
      })
      .catch(error => {
        console.log(error)
        this.$neoNotify.error(error)
      })
  }, */
  created() {
    this.searchProduct = debounce(this.searchProduct, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      current: 1,
      pageSize: 10,
      selectedClass: undefined,
      selectedType: undefined,
      selectedSession: undefined,
      sectionSpinning: false,
      classSpinning: false,
      search: null,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getProductTransactions: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }
      this.$http.get('/api/inventory/bundled_transaction/all', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
          transaction_type: this.selectedType === 'undefined' ? undefined : this.selectedType,
        },
        /* this.$http.get('/api/student', {
          params: {
            limit: this.pageSize,
            page: page,
            search: this.search,
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            session_id: this.selectedSession,
          }, */
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchProduct: function(value) {
      this.search = value
      this.getProductTransactions(true)
    },
    onChangeSearchProducts: function(e) {
      this.search = e.target.value
      this.getProductTransactions(true)
    },
    handleCreated: function() {
      this.getProductTransactions()
    },
    handleUpdateTable: function() {
      this.getProductTransactions()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getProductTransactions()
    },
    onChange(current) {
      this.current = current
      this.getProductTransactions()
    },
    /* getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    }, */
    /* handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
      this.getProductTransactions()
    }, */
    /* getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    }, */
    handleTypeChange (value) {
      if (value) {
        this.selectedType = value
        this.getProductTransactions()
      } else {
        this.selectedType = undefined
        this.getProductTransactions()
      }
    },
    /* handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.getProductTransactions()
    }, */
    /* handleDeleteSelected() {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete the selected students?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/students', {
              params: {
                student_ids: this.selectedRowKeys,
              },
            })
            .then(() => {
              this.handleUpdateTable()
              this.selectedRowKeys = []
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'The selected students were deleted successfully',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    }, */
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
